import { getAccountCredit } from "../../../api/services";
import { useQuery } from "react-query";

export const useAccountCredit = (
  accountNumber: string,
  creditNumber: string,
) => {
  return useQuery(
    ["accounts/credits", { accountNumber, creditNumber }],
    getAccountCredit,
    {
      enabled: !!accountNumber && !!creditNumber,
    },
  );
};
